import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Numbers = () => {
  return (
    <Container className="numbers-section py-5">
      <Row className="py-4">
        <Col>
        <h5 className="text-center number-heading2 text-light-blue">
        Trusted By{" "}
            <span style={{ color: "#004D90" }}>High-Performing Engineering Teams</span>
          </h5>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col className="text-center">
          <div>
            <h2 className="number">10X</h2>
            <p className="number-subheading">Faster Test Deployment</p>
          </div>
        </Col>
        <Col className="text-center">
          <div>
            <h2 className="number">70%</h2>
            <p className="number-subheading">Reduced Testing Effort</p>
          </div>
        </Col>
        <Col className="text-center">
          <div>
            <h2 className="number">30%</h2>
            <p className="number-subheading">Shorter Development Cycle</p>
          </div>
        </Col>
      </Row>
      {/* <Row>
        <Col>
        <hr/>
        </Col>
      </Row>
      <Row className="py-4">
        <Col>
          <h5 className="text-center number-heading2 text-light-blue">
            10X Faster{" "}
            <span style={{ color: "#004D90" }}>Automated Web App Testing</span>
          </h5>
        </Col>
      </Row> */}
    </Container>
  );
};

export default Numbers;
